import Vue from 'vue';

function disableClickOutsideDataTable(el) {
  el.classList.add('disable-click-outside-data-table');
}

Vue.directive('disable-click-outside-data-table', disableClickOutsideDataTable);
